module.exports = __webpack_public_path__ + "img/ai-base-child.425db049.png";